// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import isApiError from "@insite/client-framework/Common/isApiError";
import {
    createHandlerChainRunner,
    Handler,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { updateCustomerPartNumber } from "@steiner/App/Services/CustomerPartNumbersServices";

interface Props {}

export interface UpdateCustomerPartNumberParameter {
    customerPartNumber?: string;
}

type HandlerType = Handler<UpdateCustomerPartNumberParameter, Props>;

export const DispatchUpdatingSearchField: HandlerType = props => {
    props.dispatch({
        type: "xCustomerPartNumbers/UpdateSearchField",
        customerPartNumber: props.parameter.customerPartNumber,
    } as any);
};

export const chain = [DispatchUpdatingSearchField];

const updateSearchField = createHandlerChainRunner(chain, "UpdateSearchField");

export default updateSearchField;
